module.exports = "/_next/static/images/contentMarketingImage2x-fd4c18c31d93119ac3eee2ba5b8a4944.png.webp";